angular.module('aprima-core-ui')
    .directive('apTileManager', [function () {
        'use strict';

        return {
            restrict: 'EA',
            controller: ['$scope', '$attrs', 'TileGroup', 'Bridge', function($scope, $attrs, TileGroup, Bridge) {
                var self = this;
                self.tileGroup = new TileGroup(
                    $scope.$eval($attrs.groupName),
                    $scope.$eval($attrs.tileConfiguration),
                    $scope.$eval($attrs.storageMode),
                    !!$scope.$eval($attrs.disablePersistence));

                var configurationWatch = $scope.$watch($attrs.tileConfiguration, function(newVal, oldVal) {
                    if(newVal !== oldVal) {
                        self.tileGroup.changeConfiguration(newVal);
                    }
                });

                var persistenceWatch = $scope.$watch($attrs.disablePersistence, function(newVal, oldVal) {
                    if(newVal !== oldVal) {
                        self.tileGroup.setPersistence(!newVal);
                    }
                });

                Bridge.on('change-tile-state', $scope, function () {
                    self.tileGroup.nextState();
                });

                $scope.$on('$destroy', function() {
                    configurationWatch();
                    persistenceWatch();
                });
            }],
        };
    }]);
